import { Component } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'mh-footer',
  templateUrl: './footer.component.html',
  imports: [SvgIconComponent],
  styleUrls: ['footer.component.scss'],
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
}
